import { Pipe, PipeTransform } from '@angular/core';
import { Product } from '../models/product';

@Pipe({
  name: 'brandFirst',
  standalone: true,
})
export class BrandFirstPipe implements PipeTransform {
  // Accept either a full Product or a plain string[] of brands
  transform(value: Product | string[] | null | undefined): string {
    if (!value) {
      return '';
    }

    // Case 1: value is a brands array
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return '';
      }
      const first = value[0];
      return typeof first === 'string' ? first : '';
    }

    // Case 2: value is a Product
    const product = value as Product;
    if (!product.brands || product.brands.length === 0) {
      return '';
    }

    const first = product.brands[0];
    return typeof first === 'string' ? first : '';
  }
}
